module.exports = __webpack_public_path__ + "static/media/key-replacement_color.41e8aa95.png";